// extracted by mini-css-extract-plugin
export default {"container":"x8UCH8","narrow":"fTJ5Pd","border":"Uep3yo","loadMoreWrapper":"nfGGhr"};